import { render, staticRenderFns } from "./SalesAdd.vue?vue&type=template&id=76c0faea&scoped=true&"
import script from "./SalesAdd.vue?vue&type=script&lang=js&"
export * from "./SalesAdd.vue?vue&type=script&lang=js&"
import style0 from "./SalesAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SalesAdd.vue?vue&type=style&index=1&id=76c0faea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c0faea",
  null
  
)

export default component.exports